import {
  isVideoGenerationCard,
  Message,
  MessageSkill,
  TaskState,
} from 'src/types';
import styles from './ThreadVideoGenCard.module.scss';
import { FeedbackRating } from '../FeedbackRating';
import { ThreadVideoPayer } from 'src/v2/components/ThreadVideoPayer';
import { DownloadVideoButton } from 'src/v2/components/ThreadMessage/components/DownloadVideoButton';
import { useMemo } from 'react';
import { MoreMessageActionsTool } from '../MoreMessageActionsTool';

interface ThreadVideoGenCardProps {
  message: Message;
  isStreaming: boolean;
  taskState?: TaskState;
}

export const ThreadVideoGenCard = ({
  message,
  isStreaming = false,
  taskState,
}: ThreadVideoGenCardProps) => {
  const isDisabled = useMemo(
    () => taskState !== TaskState.DONE || isStreaming,
    [taskState, isStreaming],
  );
  if (!isVideoGenerationCard(message.payload)) {
    return null;
  }

  const {
    payload: { videos },
  } = message;

  return (
    <div className={styles.root}>
      <div className={styles.list}>
        {Object.entries(videos || {}).map(([key, item]) => (
          <ThreadVideoPayer key={key} data={item} isStreaming={isStreaming} />
        ))}
      </div>

      {!isStreaming && (
        <div className={styles.actionsWrapper}>
          <DownloadVideoButton message={message} isDisabled={isDisabled} />

          <MoreMessageActionsTool message={message} disabled={isStreaming} />
        </div>
      )}

      {!isStreaming && (
        <FeedbackRating
          title="Rate the video"
          message={message}
          isStreaming={false}
          operationType="message-level"
          messageSkill={MessageSkill.VIDEO_GENERATION}
        />
      )}
    </div>
  );
};
